import { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import { gsap } from "gsap"
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

import "./AnimalRevealAnimation.scss"

import historyBack from "../../../../../../assets/games/AnimalSorat/History.png"
import historyBack_pot from "../../../../../../assets/games/AnimalSorat/History_mobile.svg"
import Chips from "../../../../../../library/Chips/Chips";
import BetPlacedChip from "../../../../../../library/Chips/BetChip";

import TOTAIS from "../../../../../../assets/games/AnimalSorat/animals/Animals-01.png"
import PYTHON from "../../../../../../assets/games/AnimalSorat/animals/Animals-02.png"
import ELEPHANT from "../../../../../../assets/games/AnimalSorat/animals/Animals-03.png"
import DEER from "../../../../../../assets/games/AnimalSorat/animals/Animals-04.png"
import PIG from "../../../../../../assets/games/AnimalSorat/animals/Animals-05.png"
import EAGLE from "../../../../../../assets/games/AnimalSorat/animals/Animals-06.png"
import MEERKAT from "../../../../../../assets/games/AnimalSorat/animals/Animals-07.png"
import TIGER from "../../../../../../assets/games/AnimalSorat/animals/Animals-08.png"
import GIANT_PANDA from "../../../../../../assets/games/AnimalSorat/animals/Animals-09.png"
import OWL from "../../../../../../assets/games/AnimalSorat/animals/Animals-10.png"
import PARROT from "../../../../../../assets/games/AnimalSorat/animals/Animals-11.png"
import MONKEY from "../../../../../../assets/games/AnimalSorat/animals/Animals-12.png"
import LION from "../../../../../../assets/games/AnimalSorat/animals/Animals-13.png"
import TOUCAN from "../../../../../../assets/games/AnimalSorat/animals/Animals-14.png"
import RABIT from "../../../../../../assets/games/AnimalSorat/animals/Animals-15.png"
import KING_KONG from "../../../../../../assets/games/AnimalSorat/animals/Animals-16.png"
import CHEETAH from "../../../../../../assets/games/AnimalSorat/animals/Animals-17.png"
import RAM from "../../../../../../assets/games/AnimalSorat/animals/Animals-18.png"
import HEN from "../../../../../../assets/games/AnimalSorat/animals/Animals-19.png"
import DOG from "../../../../../../assets/games/AnimalSorat/animals/Animals-20.png"
import HORSE from "../../../../../../assets/games/AnimalSorat/animals/Animals-21.png"
import RHINOCEROS from "../../../../../../assets/games/AnimalSorat/animals/Animals-22.png"
import FOX from "../../../../../../assets/games/AnimalSorat/animals/Animals-23.png"
import DUCK from "../../../../../../assets/games/AnimalSorat/animals/Animals-24.png"
import SNAIL from "../../../../../../assets/games/AnimalSorat/animals/Animals-25.png"

import TOTAIS_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/1.png"
import PYTHON_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/2.png"
import ELEPHANT_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/3.png"
import DEER_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/4.png"
import PIG_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/5.png"
import EAGLE_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/6.png"
import MEERKAT_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/7.png"
import TIGER_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/8.png"
import GIANT_PANDA_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/9.png"
import OWL_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/10.png"
import PARROT_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/11.png"
import MONKEY_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/12.png"
import LION_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/13.png"
import TOUCAN_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/14.png"
import RABIT_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/15.png"
import KING_KONG_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/16.png"
import CHEETAH_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/17.png"
import RAM_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/18.png"
import HEN_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/19.png"
import DOG_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/20.png"
import HORSE_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/21.png"
import RHINOCEROS_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/22.png"
import FOX_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/23.png"
import DUCK_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/24.png"
import SNAIL_History from "../../../../../../assets/games/AnimalSorat/HistoryImages/25.png"

import box_front from "../../../../../../assets/games/AnimalSorat/Box/box-front.webp"
import box_back from "../../../../../../assets/games/AnimalSorat/Box/box-back.webp"
import box_dust from "../../../../../../assets/games/AnimalSorat/Box/box-dust.png"
import box_shadow from "../../../../../../assets/games/AnimalSorat/Box/box-shadow.png"
import box_top_shadow from "../../../../../../assets/games/AnimalSorat/Box/box-top-shadow.png"
import box_top from "../../../../../../assets/games/AnimalSorat/Box/box-top.webp"
import piece0 from "../../../../../../assets/games/AnimalSorat/Box/piece0.webp"
import piece1 from "../../../../../../assets/games/AnimalSorat/Box/piece1.webp"
import piece2 from "../../../../../../assets/games/AnimalSorat/Box/piece2.webp"
import useSafeTimeout from "../../../../Utillitys/useSafeTimeout";

const ANIMAL_DETAILS = [
    {
        "animalName": "TOTAIS",
        "animalSrc": TOTAIS,
        "animalHistorySrc": TOTAIS_History
    },
    {
        "animalName": "PYTHON",
        "animalSrc": PYTHON,
        "animalHistorySrc": PYTHON_History
    },
    {
        "animalName": "ELEPHANT",
        "animalSrc": ELEPHANT,
        "animalHistorySrc": ELEPHANT_History
    },
    {
        "animalName": "DEER",
        "animalSrc": DEER,
        "animalHistorySrc": DEER_History
    },
    {
        "animalName": "PIG",
        "animalSrc": PIG,
        "animalHistorySrc": PIG_History
    },
    {
        "animalName": "EAGLE",
        "animalSrc": EAGLE,
        "animalHistorySrc": EAGLE_History
    },
    {
        "animalName": "MEERKAT",
        "animalSrc": MEERKAT,
        "animalHistorySrc": MEERKAT_History
    },
    {
        "animalName": "TIGER",
        "animalSrc": TIGER,
        "animalHistorySrc": TIGER_History
    },
    {
        "animalName": "GIANT PANDA",
        "animalSrc": GIANT_PANDA,
        "animalHistorySrc": GIANT_PANDA_History
    },
    {
        "animalName": "OWL",
        "animalSrc": OWL,
        "animalHistorySrc": OWL_History
    },
    {
        "animalName": "PARROT",
        "animalSrc": PARROT,
        "animalHistorySrc": PARROT_History
    },
    {
        "animalName": "MONKEY",
        "animalSrc": MONKEY,
        "animalHistorySrc": MONKEY_History
    },
    {
        "animalName": "LION",
        "animalSrc": LION,
        "animalHistorySrc": LION_History
    },
    {
        "animalName": "TOUCAN",
        "animalSrc": TOUCAN,
        "animalHistorySrc": TOUCAN_History
    },
    {
        "animalName": "RABIT",
        "animalSrc": RABIT,
        "animalHistorySrc": RABIT_History
    },
    {
        "animalName": "KING KONG",
        "animalSrc": KING_KONG,
        "animalHistorySrc": KING_KONG_History
    },
    {
        "animalName": "CHEETAH",
        "animalSrc": CHEETAH,
        "animalHistorySrc": CHEETAH_History
    },
    {
        "animalName": "RAM",
        "animalSrc": RAM,
        "animalHistorySrc": RAM_History
    },
    {
        "animalName": "HEN",
        "animalSrc": HEN,
        "animalHistorySrc": HEN_History
    },
    {
        "animalName": "DOG",
        "animalSrc": DOG,
        "animalHistorySrc": DOG_History
    },
    {
        "animalName": "HORSE",
        "animalSrc": HORSE,
        "animalHistorySrc": HORSE_History
    },
    {
        "animalName": "RHINOCEROS",
        "animalSrc": RHINOCEROS,
        "animalHistorySrc": RHINOCEROS_History
    },
    {
        "animalName": "FOX",
        "animalSrc": FOX,
        "animalHistorySrc": FOX_History
    },
    {
        "animalName": "DUCK",
        "animalSrc": DUCK,
        "animalHistorySrc": DUCK_History
    },
    {
        "animalName": "SNAIL",
        "animalSrc": SNAIL,
        "animalHistorySrc": SNAIL_History
    }]

gsap.registerPlugin(MotionPathPlugin);

const AnimalSoratGameBoard = forwardRef((props, ref) => {

    const [history, updateHistory] = useState([...props.gameState.history])

    const isReady = useRef(false)
    const hasRevealed = useRef(false)
    const closeTimeline = useRef(null);
    const closeTriggered = useRef(false);
    const canClose = useRef(false);
    const hasClosed = useRef(false);
    const historyMoved = useRef(false);
    const firstRender = useRef(true);
    const { setSafeTimeout } = useSafeTimeout()
    useImperativeHandle(ref, () => ({
        firstAnimation,
        triggerReveal,
        closeAnimation,
        animateResultToHistory,
        updateHistory
    }))


    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }

        animateResultToHistory();
    }, [history]);


    const firstAnimation = () => {

        closeTriggered.current = false

        gsap.set("#resultDeclareBack", { opacity: 0, display: "none" });
        gsap.set("#resultDeclare", { scale: 0, opacity: 0, y: 50 });
        gsap.set(".winnerAnimalDeclare, .box_dust, .wood_piece, .sun_rays, .winnerNumberDeclare", {
            opacity: 0,
            display: "none",
        });

        // Keep the top *aligned with the box body* initially
        gsap.set(".box_top", {
            y: 0,
            x: -10,
            rotation: 0,
            opacity: 1,
            // transformOrigin: "center bottom",
        });

        const tl = gsap.timeline({ defaults: { ease: "back.out(1.7)" } });

        tl.set("#resultDeclareBack", { display: "block" })
            .to("#resultDeclareBack", {
                opacity: 1,
                duration: 0.4,
                ease: "power2.inOut",
            })
            .to(
                "#resultDeclare",
                {
                    scale: 1.5,
                    opacity: 1,
                    y: "-50%",
                    x: "-50%",
                    duration: 0.6,
                },
                "<0.1"
            )
            .add(() => {
                isReady.current = true;
                if (hasRevealed.current === "queued") {
                    triggerReveal();
                } else {
                    document.querySelector("#resultDeclare").classList.add("jump-shaking");
                    // props.playTheSound("boxKnock",true,1000)
                }
            });
    };

    const triggerReveal = () => {
        if (hasRevealed.current === true) return;
        if (!isReady.current) {
            hasRevealed.current = "queued";
            return;
        }

        if (closeTimeline.current) {
            closeTimeline.current.kill();
            closeTimeline.current = null;
        }

        hasRevealed.current = true;

        const box = document.querySelector("#resultDeclare");
        box.classList.remove("jump-shaking");

        const tl = gsap.timeline({
            defaults: { ease: "power2.out" }
        });
        tl.addLabel("burst", "<");
        // 🎩 Box top pops & flies off
        tl.to(".box_top", {
            y: -80,
            rotation: -8,
            duration: 0.45,
            opacity: 0,
            ease: "back.out(1.8)",
            onStart: () => {
                // 💥 Trigger debris burst as lid rises
                createDebrisBurst();
                props.playTheSound("woodBreak");
            },
        })
            .to(".box_top", {
                y: -220,
                rotation: 60,
                scale: 1.08,
                opacity: 0,
                duration: 0.5,
                ease: "power4.out",
            });

        // 🐾 Animal Reveal (simultaneous with debris)
        tl.set(".winnerAnimalDeclare", { display: "block", opacity: 0, scale: 0.8 }, "burst+=0.05");
        tl.to(
            ".winnerAnimalDeclare",
            {
                opacity: 1,
                scale: 1.25,
                y: "-50%",
                x: "-50%",
                duration: 0.55,
                ease: "back.out(1.7)",
                onStart: () => {
                    props.playTheSound("AnimalReveal")
                }
            },
            "burst+=0.01"
        );

        // Label for sync

        // Micro shake
        tl.to(
            "#resultDeclare",
            {
                x: "+=6",
                y: "+=4",
                duration: 0.05,
                repeat: 8,
                yoyo: true,
                ease: "power1.inOut",
            },
            "burst+=0.02"
        );

        // 🌟 Sun rays & dust puff
        tl.add(() => {
            gsap.set(".sun_rays", { display: "block", scale: 0.8 });
            gsap.to(".sun_rays", { opacity: 1, scale: 1, duration: 0.45, ease: "power2.out" });

            gsap.set(".box_dust", { display: "block" });
            gsap.to(".box_dust", { opacity: 1, scale: 1.25, duration: 0.18, ease: "power1.out" });
            gsap.to(".box_dust", { opacity: 0, scale: 1.9, duration: 0.8, delay: 0.12, ease: "power2.in" });
        }, "burst+=0.05");



        // 🔢 Number Reveal (bounce to front-right corner)
        // 🔢 Winning Number Reveal — natural "pop out of box"
        // 🎯 Cinematic Horseshoe Motion (to the right)
        tl.set(
            ".winnerNumberDeclare",
            {
                display: "block",
                opacity: 0,
                scale: 0.5,
                xPercent: -50,
                yPercent: -50,
                y: "+=60", // starts slightly inside the box
            },
            "burst"
        );

        // 🌀 Smooth horseshoe-like trajectory toward the right
        tl.to(
            ".winnerNumberDeclare",
            {
                opacity: 1,
                scale: 1.2,
                duration: 1.4,
                ease: "power2.inOut",
                motionPath: {
                    path: [
                        { x: 0, y: 60 },      // start inside box
                        { x: 50, y: -120 },   // moves up & right
                        { x: 110, y: -40 },   // starts descending
                        { x: 140, y: 10 },    // curving down to final
                        { x: 70, y: 30 },     // final rest position
                    ],
                    curviness: 1.25,
                    autoRotate: false,
                },
            },
            "burst+=0.05"
        );

        // 💥 Gentle bounce settle
        tl.to(
            ".winnerNumberDeclare",
            {
                y: "+=8",
                scale: 1,
                duration: 0.6,
                ease: "elastic.out(1, 0.4)",
            },
            "-=0.3"
        );
        // ✅ Add a final dummy tween to give GSAP a proper endpoint
        tl.to({}, { duration: 0.01 }, "+=0.1");

        // ✅ Register onComplete AFTER all tweens are built
        tl.eventCallback("onComplete", () => {
            const balanceTimeout = setSafeTimeout(() => {
                if (props?.getGameStatePlayerBalance) {
                    props.getGameStatePlayerBalance();
                }
            }, 3000);

            // 🧹 Optional: clean up if the component unmounts
            if (window.addEventListener) {
                const cancelTimeout = () => clearTimeout(balanceTimeout);
                window.addEventListener("beforeunload", cancelTimeout);
            }
        });


        // ✅ Helper: debris scatter with clones
        function createDebrisBurst() {
            const debrisClasses = [".piece1", ".piece2", ".piece3"];
            const container = document.querySelector("#resultDeclare");

            debrisClasses.forEach((sel) => {
                for (let i = 0; i < 6; i++) {
                    const base = document.querySelector(sel);
                    if (!base) continue;

                    const clone = base.cloneNode(true);
                    container.appendChild(clone);

                    // 🎬 Random depth layer (front, mid, back)
                    const depthLayer = gsap.utils.random(["front", "mid", "back"]);
                    let scale = 1;
                    let blur = 0;

                    switch (depthLayer) {
                        case "front":
                            scale = gsap.utils.random(1.1, 1.5);
                            blur = 0;
                            break;
                        case "mid":
                            scale = gsap.utils.random(0.8, 1.1);
                            blur = 1;
                            break;
                        case "back":
                            scale = gsap.utils.random(0.5, 0.8);
                            blur = 2;
                            break;
                    }

                    gsap.set(clone, {
                        display: "block",
                        opacity: 0,
                        x: 0,
                        y: 0,
                        scale,
                        filter: `blur(${blur}px)`,
                        transformOrigin: "center",
                    });

                    // 🎯 Random scatter direction & distance
                    const angle = gsap.utils.random(0, 360, 1);
                    const distance = gsap.utils.random(100, 280);
                    const rad = (angle * Math.PI) / 180;
                    const targetX = Math.cos(rad) * distance;
                    const targetY = Math.sin(rad) * distance;

                    // 💥 Outward scatter animation
                    gsap.to(clone, {
                        opacity: 1,
                        x: targetX,
                        y: targetY,
                        rotation: gsap.utils.random(-180, 180),
                        duration: gsap.utils.random(0.45, 0.8),
                        ease: "power3.out",
                        onComplete: () => {
                            // 🌀 Drift down + fade out
                            gsap.to(clone, {
                                y: `+=${gsap.utils.random(180, 300)}`,
                                opacity: 0,
                                scale: scale * gsap.utils.random(0.7, 0.9),
                                filter: `blur(${blur + 1}px)`,
                                duration: gsap.utils.random(1, 1.4),
                                ease: "power2.in",
                                onComplete: () => clone.remove(),
                            });
                        },
                    });
                }
            });
        }


    };


    // ✅ PART 3 — Cinematic Close

    const closeAnimation = () => {
        // If already closed, ignore
        // if (hasClosed.current) return;
        // closeTriggered.current = true;

        // // If it's too early, just mark intent and wait for timer
        // if (!canClose.current) return;

        // hasClosed.current = true;

        const tl = gsap.timeline();

        tl.to(".winnerAnimalDeclare", {
            scale: 0.8,
            opacity: 0,
            duration: 0.4,
            ease: "power2.inOut",
        }, "-=0.1");

        tl.to(".sun_rays", {
            opacity: 0,
            scale: 1.2,
            duration: 0.4,
            ease: "power2.in",
        }, "<");

        tl.to("#resultDeclare", {
            y: "+=120",
            scale: 0.8,
            opacity: 0,
            duration: 0.5,
            ease: "power3.in",
        }, "-=0.1");

        tl.to("#resultDeclareBack", {
            opacity: 0,
            duration: 0.5,
            ease: "power1.inOut",
            onComplete: () => {
                gsap.set("#resultDeclareBack", { display: "none" });
                isReady.current = false;
                hasRevealed.current = false;
                props.onAnimationCompleted()
            },
        }, "<");
    };

    function animateResultToHistory() {

        // if (historyMoved.current) return;

        // // If it's too early, just mark intent and wait for timer
        // if (!canClose.current) return;

        // historyMoved.current = true;

        const resultAnimal = document.querySelector("#resultDeclare .winnerAnimalDeclare");
        const historyBox = document.querySelector(".lastHistoryBox");

        if (!resultAnimal || !historyBox) return;

        // Temporarily clone the image inside the history box to animate it,
        // without disturbing layout during the flight.
        const targetImg = historyBox.querySelector(".historyAnimal");
        const ghost = targetImg.cloneNode(true);
        document.body.appendChild(ghost);

        // Source and destination positions
        const srcRect = resultAnimal.getBoundingClientRect();
        const tgtRect = targetImg.getBoundingClientRect();

        const startX = srcRect.left + srcRect.width / 2;
        const startY = srcRect.top + srcRect.height / 2;
        const endX = tgtRect.left;
        const endY = tgtRect.top;

        // Mid control point for tight outward spiral motion
        const dx = endX - startX;
        const dy = endY - startY;
        const cx = startX + dx * 0.4;
        const cy = startY + dy * 0.4;

        const path = [
            { x: startX, y: startY },
            { x: cx + dy * 0.25, y: cy - dx * 0.25 },
            { x: endX, y: endY },
        ];

        // Prepare the ghost

        gsap.set(targetImg, {
            opacity: 0
        })

        gsap.set(ghost, {
            position: "fixed",
            left: 0,
            top: 0,
            x: startX,
            y: startY,
            width: tgtRect.width,
            height: tgtRect.height,
            transformOrigin: "center center",
            zIndex: 9999,
            opacity: 1,
            scale: 2,
            pointerEvents: "none",
            filter: "drop-shadow(0 0 20px rgba(255, 230, 120, 0.9))",
        });

        // Animate along the spiral path
        const tl = gsap.timeline({
            onStart: () => {
                props.playTheSound("swingSound")
            },
            onComplete: () => {
                ghost.remove(); // remove the ghost
                // restore the real history image (fade in)
                gsap.fromTo(
                    targetImg,
                    { opacity: 0, scale: 1.2 },
                    { opacity: 1, scale: 1, duration: 0.4, ease: "back.out(1.8)" }
                );
                props.setDupBetAmt()
            },
        });

        tl.to(ghost, {
            duration: 1,
            ease: "power2.inOut",
            opacity: 1,
            motionPath: {
                path,
                curviness: 1.3,
            },
            scale: 0.9,
        }).to(
            ghost,
            {
                scale: 0.7,
                rotation: 0,
                duration: 0.25,
                ease: "power1.out",
            },
            "-=0.2"
        );
    }

    // When clicking on the entire animal box (but not a button)
    const handleAnimalClick = (e, idx) => {
        props.betPlacedOn("animal", idx);
    };

    // When clicking on one of the number buttons
    const handleNumberClick = (e, numberIndex) => {
        props.betPlacedOn("numbers", numberIndex);
    };



    const chipSelectionFn = (value, index) => {
        if (props.isBetFreezed) {
            return
        }
        let newValues = { value, index }
        props.setSelectedChip({ ...newValues })
        props.playTheSound("pokerChipSound")
    }


    return <div id="AnimalSoratGameBoard" className="animalSoratGameBoard">
        <div className="AnimalSoratAnimalBoard">
            {ANIMAL_DETAILS.map((ele, idx) => {
                // Format for boxNumber
                const formattedBoxNumber = (idx + 1) <= 9 ? `0${idx + 1}` : (idx + 1) === 100 ? '00' : idx + 1;

                // Function to format the range numbers
                const formatRangeNumber = (num) => num === 100 ? '00' : String(num).padStart(2, '0');

                return (
                    <div
                        className={`animalBoxes ${idx % 2 ? 'bg-box1' : 'bg-box0'} ${props.winningAnimal === idx ? "winAnimalAnimation" : ""
                            }`}
                        key={ele.animalName}
                    >
                        <div className="animals"
                            onClick={(e) => handleAnimalClick(e, idx)}
                        >
                            <img src={ele.animalSrc} className="animalImage" alt="" />
                            <div className="animalName">{ele.animalName}</div>
                            {Boolean(props.betObject[idx]) && (
                                <div className="AnimalSoratBetPlacedChip">
                                    <BetPlacedChip
                                        betAmount={props.betObject[idx]}
                                        chipString={props.as_chipValues}
                                        gameId={props.gameId}
                                        chipWidth="100%"
                                        chipHeight="100%"
                                        minFontSize={80}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="animalRange">
                            {[0, 1, 2, 3].map((n) => {
                                const numberIndex = (idx * 4) + n;
                                const displayNumber = formatRangeNumber((idx + 1) * 4 - (3 - n));
                                return (
                                    <div className="boxNumber" key={numberIndex} onClick={(e) => handleNumberClick(e, numberIndex)}>
                                        <button>
                                            {displayNumber}
                                        </button>
                                        {Boolean(props.splitBetObject[numberIndex]) && (
                                            <div className="numberBetChip">
                                                <BetPlacedChip
                                                    betAmount={props.splitBetObject[numberIndex]}
                                                    chipString={props.as_chipValues}
                                                    gameId={props.gameId}
                                                    chipWidth="100%"
                                                    chipHeight="100%"
                                                    minFontSize={80}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                    </div>

                );
            })}

        </div>
        <div className="animalSoratHistoryChips">
            {<div id="AnimalSoratHistoryTable" className="AnimalSoratHistoryTable" style={{ backgroundImage: `url(${window.innerHeight < window.innerWidth ? historyBack : historyBack_pot})` }}>
                <div className="historyDiv">
                    {/* {props.gameState.history?.map((ele, idx) => { */}
                    {history?.map((ele, idx) => {
                        let resultNo = Number(ele.resultNo) || 100
                        let result = ANIMAL_DETAILS[Math.ceil(resultNo / 4) - 1]
                        // return (<div className={`histroyBox ${props.gameState.history.length - 1 === idx ? "lastHistoryBox" : ""}`} key={ele.resultNo}>
                        return (<div className={`histroyBox ${history.length - 1 === idx ? "lastHistoryBox" : ""}`} key={ele.handId}>
                            <img className="historyAnimal" src={result.animalHistorySrc} alt="" />
                            <div className="historyWinNumber">{resultNo === 100 ? '00' : String(resultNo).padStart(2, '0')}</div>
                        </div>)
                    })}
                </div>
                <span className="animalSoratHistoryText">HISTORY</span>
            </div>}
            <div id="AnimalSoratChipsController">
                <Chips gameChips={props.as_chipValues} containerClassName="animalSoratBetChipsContainer" selectedChipIndex={props.selectedChip.index} chipSelectionFn={chipSelectionFn} isMobile={true} chipWidth="100%" chipHeight="100%" ></Chips>
            </div>
        </div>
        <div id="resultDeclareBack">
            <div id="resultDeclare">
                <div className="sun_rays" aria-hidden="true" />
                <img className="box_back" src={box_back} alt="" />
                <img className="box_dust" src={box_dust} alt="" />
                <img className="box_front" src={box_front} alt="" />
                <img className="box_shadow" src={box_shadow} alt="" />
                <img className="box_top" src={box_top} alt="" />
                <img className="box_top_shadow" src={box_top_shadow} alt="" />
                <img className={`winnerAnimalDeclare${props.winningAnimal === 9 ? " owlAnimal" : ""}`} src={ANIMAL_DETAILS[props.winningAnimal]?.animalSrc} alt="" />
                <div className="winnerNumberDeclare">{props.winningNumber === 100 ? '00' : String(props.winningNumber).padStart(2, '0')}</div>
                <img className="wood_piece piece1" src={piece0} alt="" />
                <img className="wood_piece piece2" src={piece1} alt="" />
                <img className="wood_piece piece3" src={piece2} alt="" />
            </div>
        </div>
    </div>
})


export default memo(AnimalSoratGameBoard)